import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HeatmapModule from 'highcharts/modules/heatmap';
import { t } from 'i18next';
import {heatmapColorStops} from "@/pages/residents/detail/benTrendAnalysis/common";

HeatmapModule(Highcharts);

interface Props {
  averageHeatmap: AverageHeatmapProps;
  colorMin: number;
  colorMax: number;
  postFix?: string;
  isPrinting?: boolean;
}

interface AverageHeatmapProps {
  data: number[][];
  xCategories: string[];
  yCategories: string[];
}

// 平均Heatmap生成
export const AverageHeatmapGraph = React.memo((
    {
      averageHeatmap,
      colorMin,
      colorMax,
      postFix = '',
      isPrinting = false
    }: Props) => {
  const xAxisCategories = averageHeatmap.xCategories ? averageHeatmap.xCategories : [];
  const xAxisMax =averageHeatmap.xCategories ? averageHeatmap.xCategories.length - 1 : 0;

  const colorStops = heatmapColorStops['commonTrend'];

  const option: Highcharts.Options = {
    title: {
      text: '',
    },
    chart: {
      zoomType: 'x',
      height: 28,
      marginLeft: 72,
      marginRight: isPrinting ? 180 : 0,
      marginTop: 0,
      marginBottom: 0,
      shadow: false,
      animation: false,
      backgroundColor: '#FFFFFF',
    },
    xAxis: {
      categories: xAxisCategories,
      min: 0,
      max: xAxisMax,
      tickInterval: 2,
      visible: false,
    },
    yAxis: {
      categories: [t('average', '平均')],
      reversed: false,
      gridLineWidth: 0,
      title: { text: '' },
      labels: {
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
        },
      },
    },
    colorAxis: {
      min: colorMin,
      floor: 0,
      max: colorMax,
      stops: colorStops,
    },
    series: [
      {
        type: 'heatmap',
        boostThreshold: 100,
        data: averageHeatmap.data,
        colsize: 1,
        rowsize: 1,
        index: 0,
        turboThreshold: Number.MAX_VALUE,
        dataLabels: {
          enabled: true,
          color: '#000000',
          style: {
            fontSize: '12px',
          },
          formatter: function() {
            return Math.floor(this.point.value ?? 0);
          },
        },
        tooltip: {
          headerFormat: '',
          pointFormat: `<b>${t('average', '平均')} {point.value}${postFix}</b><br/>`,
        },
      },
    ],
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    boost: {
      useGPUTranslations: true,
    },
  };

  React.useEffect(() => {
    Highcharts.charts.forEach((chart) => {
      if (chart) {
        chart.reflow();
      }
    });
  }, [isPrinting]);

  return <HighchartsReact highcharts={Highcharts} options={option} />;
});
